import { render, staticRenderFns } from "./betriebsanweisungTemplates.vue?vue&type=template&id=4a8327b6&scoped=true"
import script from "./betriebsanweisungTemplates.vue?vue&type=script&lang=js"
export * from "./betriebsanweisungTemplates.vue?vue&type=script&lang=js"
import style0 from "./betriebsanweisungTemplates.vue?vue&type=style&index=0&id=4a8327b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8327b6",
  null
  
)

export default component.exports